import React, { useState, useEffect } from 'react'
import { Box, Grid, Card, Group, Flex, Button,ThemeIcon, Text, NumberFormatter, ActionIcon, Divider, Drawer } from '@mantine/core'
import classes from '../../../../assets/module-css/AdminLayout.module.css'
import { IconBox, IconCashBanknote, IconShoppingCart, IconPackage, IconWeight, IconCalculator, IconRefresh } from '@tabler/icons-react'
import { useSelector } from 'react-redux'
import { getDetailOrderItems } from '../../../../services/orders'
import FormAdjustLogistic from './Form/FormAdjustLogistic'

const OrderLogistic = () => {
  const { isLoadingOrder, summary, logistic } = useSelector(state => state.order_detail)
  const [loadingTotal, setLoadingTotal] = useState(true)
  const [totalLandedCost, setTotalLandedCost] = useState(0)
  const [totalRevisedLandedCost, setTotalRevisedLandedCost] = useState(0)
  const [openAdjustCbm, setOpenAdjustCbm] = useState(false)

  const handleGetTotalCost = async (orderId) => {
    setLoadingTotal(true)
    const params = {
      'fields[order_item]': 'landed_cost,revised_landed_cost,quantity,revised_quantity',
    }
    try {
      const response = await getDetailOrderItems(orderId, params)
      if (response.success) {
        const dataItems = response.data

        const remapTotalItems = dataItems.map((val) => {
          const useQuantity = val.attributes.revised_quantity ? val.attributes.revised_quantity : val.attributes.quantity
          return {
            landedCost: val.attributes.landed_cost * useQuantity,
            revisedLandedCost: val.attributes.revised_landed_cost * useQuantity,
            useRevisedLandedCost: val.attributes.revised_landed_cost ? val.attributes.revised_landed_cost * useQuantity : val.attributes.landed_cost * useQuantity,
          }
        })
        
        const countLandedCost = remapTotalItems.reduce((accumulator, currentValue) => {
          return accumulator + currentValue.landedCost
        }, 0)
        
        const countRevisedLandedCost = remapTotalItems.reduce((accumulator, currentValue) => {
          return accumulator + currentValue.revisedLandedCost
        }, 0)

        const countUseRevisedLandedCost = remapTotalItems.reduce((accumulator, currentValue) => {
          return accumulator + currentValue.useRevisedLandedCost
        }, 0)
  
        setTotalLandedCost(countLandedCost)
        setTotalRevisedLandedCost(countRevisedLandedCost > 0 ? countUseRevisedLandedCost : countRevisedLandedCost)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingTotal(false)
    }
  }

  useEffect(() => {
    if (!isLoadingOrder) {
      handleGetTotalCost(summary.orderId)
    }
    // eslint-disable-next-line
  }, [isLoadingOrder])

  const handleCustomerNeedToPay = (paymentStatus) => {
    const totalProductCost = logistic.totalProductOriginalCost || 0
    const totalCustomCharges = logistic.revisedTotalCustomCharges
      || logistic.totalCustomCharges
      || 0
    const totalLogisticCharges = logistic.totalLogisticCharges || 0
    const grandTotal = summary.grandTotal || 0
    const orderType = summary.type

    if (paymentStatus === 'unpaid balance') {
      const result = {
        amount: totalProductCost + totalCustomCharges + totalLogisticCharges,
        formula: 'Total Product Cost + Total Custom Charges + Total Logistic Charges',
      }
      return result
    } else if (paymentStatus === 'unpaid goods') {
      const result = {
        amount: totalProductCost,
        formula: 'Total Product Cost',
      }
      return result
    } else if (paymentStatus === 'unpaid logistic all in') {
      const result = {
        amount: totalCustomCharges + totalLogisticCharges,
        formula: 'Total Custom Charges + Total Logistic Charges',
      }
      return result
    } else if (paymentStatus === 'unpaid logistic') {
      const result = {
        amount: totalLogisticCharges,
        formula: 'Total Logistic Charges',
      }
      return result
    } else if (paymentStatus === 'paid goods only') {
      const result = {
        amount: grandTotal,
        formula: 'Grand Total',
      }
      return result
    } else if (paymentStatus === 'paid all') {
      if (orderType === 'forwarding') {
        return {
          amount: totalCustomCharges + totalLogisticCharges,
          formula: 'Total Custom Charges + Total Logistic Charges',
        }
      }

      const result = {
        amount: grandTotal,
        formula: 'Grand Total',
      }
      return result
    } else {
      return 0
    }
  }

  const onCloseFormAdjustCbm = () => {
    setOpenAdjustCbm(false)
  }

  return (
    <Box>
      <Box my={20}>
        <Grid align='start' overflow='hidden'>
          <Grid.Col span={6}>
            <Card withBorder shadow="xs" radius="md" padding='md' h={300}>
              <Card.Section withBorder inheritPadding py="xs">
                <Flex justify='space-between' align='center'>
                  <Group align='center' gap='xs'>
                    <ThemeIcon variant="white" size='lg'>
                      <IconBox style={{ width: '70%', height: '70%' }} />
                    </ThemeIcon>
                    <Text fz={14} fw={500}>Products</Text>
                  </Group>
                  <Button size='compact-xs' variant="outline" color='black' onClick={() => setOpenAdjustCbm(true)}>Edit</Button>
                </Flex>
              </Card.Section>
              <Card.Section withBorder inheritPadding py="xs">
                <Flex justify='space-between' align='center'>
                  <Group align='center' gap='xs'>
                    <ThemeIcon variant="light" color="blue" radius='xl'>
                      <IconPackage style={{ width: '70%', height: '70%' }} />
                    </ThemeIcon>
                    <Text fz={14} fw={500} c='gray.8'>Total Product Cost</Text>
                  </Group>
                  <Box>
                    <Text fz={14} fw={500}> <NumberFormatter prefix={`${summary.orderCurrency} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={summary.totalGoodsValueBeforeDiscount} /></Text>
                  </Box>
                </Flex>
              </Card.Section>
              <Card.Section withBorder inheritPadding py="xs">
                <Flex justify='space-between' align='center'>
                  <Group align='center' gap='xs'>
                    <ThemeIcon variant="light" color="blue" radius='xl'>
                      <IconBox style={{ width: '70%', height: '70%' }} />
                    </ThemeIcon>
                    <Text fz={14} fw={500} c='gray.8'>Total CBM</Text>
                  </Group>
                  <Group gap={!isLoadingOrder ? logistic.revisedTotalCbm ? 4 : 2 : 0} align='center'>
                    {!isLoadingOrder ? <Box className={logistic.revisedTotalCbm ? classes.PulseAnimation : ''}><Text fz={14} td={logistic.revisedTotalCbm ? 'line-through' : ''} c={logistic.revisedTotalCbm ? 'red' : 'black'}>{logistic.totalCbm}</Text></Box> : ''}
                    {!isLoadingOrder ? <Text fz={14} c='black'>{logistic.revisedTotalCbm}</Text> : ''}
                  </Group>
                </Flex>
              </Card.Section>
              <Card.Section withBorder inheritPadding py="xs">
                <Flex justify='space-between' align='center'>
                  <Group align='center' gap='xs'>
                    <ThemeIcon variant="light" color="blue" radius='xl'>
                      <IconWeight style={{ width: '70%', height: '70%' }} />
                    </ThemeIcon>
                    <Text fz={14} fw={500} c='gray.8'>Total Weight</Text>
                  </Group>
                  <Group gap={!isLoadingOrder ? logistic.revisedTotalCbm ? 4 : 2 : 0}  align='center'>
                    {!isLoadingOrder ? <Box className={logistic.revisedTotalWeight ? classes.PulseAnimation : ''}><Text fz={14} td={logistic.revisedTotalWeight ? 'line-through' : ''} c={logistic.revisedTotalWeight ? 'red' : 'black'}>{logistic.totalWeight}</Text></Box> : ''}
                    {!isLoadingOrder ? <Text fz={14} c='black'>{logistic.revisedTotalWeight} Kg</Text> : ''}
                  </Group>
                </Flex>
              </Card.Section>
              <Card.Section withBorder inheritPadding py="xs">
                <Flex justify='space-between' align='center'>
                  <Group align='center' gap='xs'>
                    <ThemeIcon variant="light" color="blue" radius='xl'>
                      <IconCalculator style={{ width: '70%', height: '70%' }} />
                    </ThemeIcon>
                    <Text fz={14} fw={500} c='gray.8'>Total Landed Cost</Text>
                  </Group>
                  <Group gap={6} align='center'>
                    {!loadingTotal ? <ActionIcon variant="transparent" size="xs" c='blue' onClick={() => handleGetTotalCost(summary.orderId)}> <IconRefresh style={{ width: '70%', height: '70%' }} stroke={1.5} /></ActionIcon> : ''}
                    {!loadingTotal ? <Text fz={14}>{<NumberFormatter prefix={`${summary.orderCurrency} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={totalLandedCost} />}</Text> : <Text fz={12} c='gray.5'>Please wait, doing calculation. . . </Text>}
                  </Group>
                </Flex>
              </Card.Section>
              <Card.Section withBorder inheritPadding py="xs">
                <Flex justify='space-between' align='center'>
                  <Group align='center' gap='xs'>
                    <ThemeIcon variant="light" color="blue" radius='xl'>
                      <IconCalculator style={{ width: '70%', height: '70%' }} />
                    </ThemeIcon>
                    <Text fz={14} fw={500} c='gray.8'>Total Revised Landed Cost</Text>
                  </Group>
                  <Group gap={6} align='center'>
                    {!loadingTotal ? <ActionIcon variant="transparent" size="xs" c='blue' onClick={() => handleGetTotalCost(summary.orderId)}> <IconRefresh style={{ width: '70%', height: '70%' }} stroke={1.5} /></ActionIcon> : ''}
                    {!loadingTotal ? <Text fz={14}>{<NumberFormatter prefix={`${summary.orderCurrency} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={totalRevisedLandedCost} />}</Text> : <Text fz={12} c='gray.5'>Please wait, doing calculation. . . </Text>}
                  </Group>
                </Flex>
              </Card.Section>
            </Card>
          </Grid.Col>
          <Grid.Col span={6}>
            <Card withBorder shadow="xs" radius="md" padding='md' h={300}>
              <Card.Section withBorder inheritPadding py="xs">
                <Group align='center' gap='xs'>
                  <ThemeIcon variant="white" size='lg'>
                    <IconCashBanknote style={{ width: '70%', height: '70%' }} />
                  </ThemeIcon>
                  <Text fz={14} fw={500}>Logistic All In</Text>
                </Group>
              </Card.Section>
              <Card.Section withBorder inheritPadding py='xs'>
                <Flex justify='space-between' align='center'>
                  <Group align='center' gap='xs'>
                    <ThemeIcon variant="light" color="blue" radius='xl'>
                      <IconShoppingCart style={{ width: '70%', height: '70%' }} />
                    </ThemeIcon>
                    <Text fz={14} fw={500} c='gray.7'>Total Custom Charge</Text>
                  </Group>
                  <Group gap={!isLoadingOrder ? logistic.revisedTotalCustomCharges ? 4 : 2 : 0}  align='center'>
                    {!isLoadingOrder ? <Box className={logistic.revisedTotalCustomCharges ? classes.PulseAnimation : ''}><Text fz={14} td={logistic.revisedTotalCustomCharges ? 'line-through' : ''} c={logistic.revisedTotalCustomCharges ? 'red' : 'blue.8'}>{<NumberFormatter prefix={`${summary.orderCurrency} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={logistic.totalCustomCharges} />}</Text></Box> : ''}
                    {!isLoadingOrder ? logistic.revisedTotalCustomCharges ? <Text fz={14} c='blue.8'>{<NumberFormatter prefix={`${summary.orderCurrency} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={logistic.revisedTotalCustomCharges} />}</Text> : '' : ''}
                  </Group>
                </Flex>
              </Card.Section>
              <Card.Section withBorder inheritPadding py="xs">
                <Flex justify='space-between' align='center'>
                  <Group align='center' gap='xs'>
                    <ThemeIcon variant="light" color="blue" radius='xl'>
                      <IconShoppingCart style={{ width: '70%', height: '70%' }} />
                    </ThemeIcon>
                    <Text fz={14} fw={500} c='gray.7'>Total Logistic Charge</Text>
                  </Group>
                  <Box>
                    {!isLoadingOrder ? <Text fz={14} c='blue.8'>{<NumberFormatter prefix={`${summary.orderCurrency} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={summary.totalLogisticChargesBeforeDiscount} />}</Text> : ''}
                  </Box>
                </Flex>
              </Card.Section>
              <Box my={10}>
                <Flex Flex justify='space-between' align='flex-start'>
                  <Group align='center' gap='xs'>
                    <Text fz={14} fw={500} c='gray.7'>Total Logistic All In</Text>
                  </Group>
                  <Box>
                    {!isLoadingOrder ? <Text fz={16} fw='bold'> <NumberFormatter prefix={`${summary.orderCurrency} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={logistic.totalLogisticCharges + (logistic.revisedTotalCustomCharges || logistic.totalCustomCharges)} /></Text> : ''}
                  </Box>
                </Flex>
              </Box>
            </Card>
          </Grid.Col>
        </Grid>
      </Box>
      <Box my={30}>
        <Grid overflow='hidden'>
          <Grid.Col span={6} offset={6}>
            <Box px={4}>
              <Flex justify='space-between' align='center'>
                <Text fz={16} fw='600' c='gray.7'>Grand Total (Calculation)</Text>
                {!isLoadingOrder ? <Text fz={16} fw='600'>{<NumberFormatter prefix={`${summary.orderCurrency} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={logistic.grandTotal} />}</Text> : ''}
              </Flex>
              <Divider size='xs' my='xs' />
              <Flex justify='space-between' align='center'>
                <Box>
                  <Text fz={16} fw='600' c='gray.7'>You Need To Pay</Text>
                  {!isLoadingOrder ? handleCustomerNeedToPay(summary.paymentStatus).formula ? <Text fz={10} fw='500' c='gray.5'>{handleCustomerNeedToPay(summary.paymentStatus).formula}</Text> : '' : ''}
                </Box>
                {!isLoadingOrder ? <Text fz={16} fw='600'>{<NumberFormatter prefix={`${summary.orderCurrency} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={handleCustomerNeedToPay(summary.paymentStatus).amount || 0} />}</Text> : ''}
              </Flex>
              <Divider size='xs' my='xs' />
              <Flex justify='space-between' align='center'>
                <Text fz={14} fw='500' c='gray.7'>Total have been Paid :</Text>
                {!isLoadingOrder ? <Text fz={14} fw='500'>{<NumberFormatter prefix={`${summary.orderCurrency} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={logistic.beenPaid} />}</Text> : ''}
              </Flex>
              <Divider size='xs' my='xs' />
              <Flex justify='space-between' align='center'>
                <Text fz={14} fw='500' c='gray.7'>Remaining Balance :</Text>
                {!isLoadingOrder ? <Text fz={14} fw='500'>{<NumberFormatter prefix={`${summary.orderCurrency} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={(handleCustomerNeedToPay(summary.paymentStatus).amount - summary.totalHaveBeenPaid) || 0} />}</Text> : ''}
              </Flex>
            </Box>
          </Grid.Col>
        </Grid>
      </Box>
      <Drawer position='right' title='Update Revised CBM & Weight' opened={openAdjustCbm} onClose={onCloseFormAdjustCbm} overlayProps={{ backgroundOpacity: 0.5, blur: 4 }}>
        <FormAdjustLogistic onCloseForm={onCloseFormAdjustCbm} />
      </Drawer>
    </Box>
    
  )
}

export default OrderLogistic 